module.exports = __webpack_public_path__ + "static/media/Exist.838d4040.png";